export const ERROR_CODE = {
  SERVICE_DISABLED: -980, // 서비스를 사용할 수 없는 상태입니다.
  COMPANY_NOT_IN_BUILDING: -990, // 건물에서 입주사를 찾을 수 없습니다.
  COMPANY_NOT_CERTIFIED: -991, // 회사 인증이 필요합니다.
};

export const SMART_OFFICE_ERROR_CODE = {
  INVALIDE_SMARTOFFICE_BUILDING: -9500, //"스마트오피스 서비스 대상 건물로 변경해 주세요"
  NOT_VERIFIED_COMPANY : -9501 //"회사 인증이 되지 않은 사용자입니다"
}

export const SMART_OFFICE_ERROR_MESSAGE = {
  NOT_VERIFIED_COMPANY: "회사 인증이 되지 않은 사용자입니다.",
  INVALIDE_SMARTOFFICE_BUILDING: "스마트오피스 서비스 대상 건물로 변경해 주세요."
}